<template>
   <div class="footer" :class="{'dark':themeName=='dark'}"><router-link to="/about">关于本站</router-link></div>
</template>
<script>
export default {
  name: 'Footer',
 
}
</script>
<style>
 .footer{
	 height: 7.2vmax;
	 width: 100vw;
	 margin:4vh 0  0 0 ;
	 display: flex;
	 align-items: center;
	 background-color:#15afef; 
	 color: #FFFFFF;
	 justify-content: center;
	  
 }
 .footer.dark{
 	background-color: #333333; 
 	color:#808080
 }
</style>
 